import { useRateLimitContext } from "@/contexts/RateLimitContext"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useFeatureFlag } from "@/contexts/FeatureFlagContext"
import { MessageSquare } from "lucide-react"
import React from "react"

export const RateLimitBadge: React.FC = () => {
  const { translate } = useTranslation()
  const chatRateLimitEnabled = useFeatureFlag("CHAT_RATE_LIMIT")
  const { remainingMessages, usedMessages, isUnlimited, isLoading, error } =
    useRateLimitContext()

  if (!chatRateLimitEnabled) {
    return null
  }

  if (isLoading || error || (!isUnlimited && remainingMessages === null)) {
    return null
  }

  const remaining = remainingMessages ?? 0
  const remainingLabel = isUnlimited ? "∞" : String(remaining)
  const total = remaining + usedMessages
  const percentageRemaining =
    !isUnlimited && total > 0 ? (remaining / total) * 100 : 100

  const isLow = percentageRemaining < 25
  const isMedium = percentageRemaining >= 25 && percentageRemaining <= 50

  return (
    <div
      className={`flex items-center gap-1 px-3 text-sm font-medium ${
        isLow ? "text-red1" : isMedium ? "text-warning" : "text-success"
      }`}
      title={translate("AI_CHAT/RATE_LIMIT_TOOLTIP")}
    >
      <MessageSquare className="h-4 w-4" />
      <span>
        {remainingLabel} {translate("AI_CHAT/MESSAGES_REMAINING")}
      </span>
    </div>
  )
}
